import React from 'react';
import { Components } from './styled';

const CheckboxComponent = ({
  checked,
  onChange,
  name,
  label,
}: {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  label: string;
}) => {
  return (
    <Components.CheckboxFieldWrapper>
      <Components.Checkbox checked={checked} onChange={onChange} name={name} />
      <Components.CheckboxLabel>{label}</Components.CheckboxLabel>
    </Components.CheckboxFieldWrapper>
  );
};

export default CheckboxComponent;
